import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberResetPasswordPage from "@/pages/member/MemberResetPasswordPage";

export const Route = createFileRoute("/member_/reset-password")({
  head: () => pageHead("Member Reset Password", "Reset your AI Innovation Network password.", "/member/reset-password", true),
  component: MemberResetPasswordPage,
});
